import React from "react";
import i18n from "i18next";
import { I18nextProvider } from "react-i18next";
import { initReactI18next } from "react-i18next";
export const wrapPageElement = ({ element, props }) => {
  const { pageContext, data } = props;

  const resources = (data?.locales?.nodes ?? []).reduce((acc, cv) => {
    acc[cv.language] = {};

    acc[cv.language]["translation"] = JSON.parse(cv.data);
    return acc;
  }, {});

  i18n.use(initReactI18next).init({
    fallbackLng: "en-US",
    lng: pageContext.language,
    resources,
  });

  if (i18n.language !== pageContext.language) {
    i18n.changeLanguage(pageContext.language);
  }
  return <I18nextProvider i18n={i18n}>{element}</I18nextProvider>;
};
